import positionsAbbJson from "@/assets/json/positionsAbb.json"
import reverseThrustAbbreviationjson from "@/assets/json/ThrustAbbreviationReverse.json";
import {Message} from "element-ui";
import abbForAffiliationAndUniversity from "@/assets/json/abbForAffiliationAndUniversity.json";
import thrustAbbreviationjson from "@/assets/json/ThrustAbbreviation.json";
import hubAbbreviationJson from "@/assets/json/hubAbbreviationReverse.json"

export default {
    data() {
        return {
            positionsAbbJson: positionsAbbJson,
            reverseThrustAbbreviationjson: reverseThrustAbbreviationjson,
            abbForAffiliationAndUniversity: abbForAffiliationAndUniversity,
            thrustAbbreviationjson: thrustAbbreviationjson,
            localHubAbbreviationJson: hubAbbreviationJson
        }
    },
    methods: {
        positionAbbreviation(position){
            if(this.positionsAbbJson.hasOwnProperty(position.toLowerCase())){
                return this.positionsAbbJson[position.toLowerCase()]
            }
            else{
                return position
            }
        },
        reverseThrustAbbreviation(abb){
            if(reverseThrustAbbreviationjson.hasOwnProperty(abb)){
                return reverseThrustAbbreviationjson[abb]
            }
            else{
                Message({
                    message: "Unknown Unit Abbreviation",
                    type: "error"
                })
                console.log(abb)
                return abb
            }
        },
        reverseHubAbbreviation(abb){
            if(this.localHubAbbreviationJson.hasOwnProperty(abb)){
                return this.localHubAbbreviationJson[abb]
            }
            else{
                Message({
                    message: "Unknown Unit Abbreviation",
                    type: "error"
                })
                console.log(abb)
                return abb
            }
        },
        getabbForAffiliationAndUniversity(name){
            if(this.abbForAffiliationAndUniversity.hasOwnProperty(name.toLowerCase())){
                return abbForAffiliationAndUniversity[name.toLowerCase()]
            }
            else{
                return name
            }
        },
        degreeAbbreviation(degree) {
            if (degree === 'Doctorate Degree') {
                return ''
            } else if (degree === 'Master\'s Degree') {
                return '(Master)'
            } else if (degree === 'Bachelor\'s Degree') {
                return '(Bachelor)'
            } else if (degree === 'Associate Degree') {
                return '(Associate)'
            }
        },
        getAbbreviation(thrustName) {
            thrustName = this.correctThrust(thrustName)
            if (this.thrustAbbreviationjson.hasOwnProperty(thrustName)) {
                if(thrustAbbreviationjson[thrustName] == 'Ctr. Comp. Sci.'){
                    return 'CCS'
                }
                if(thrustAbbreviationjson[thrustName] == 'Ctr. Tech. Entrep.'){
                    return 'CTL'
                }
                if(thrustAbbreviationjson[thrustName] == 'CLE (GZ)'){
                    return 'DLE'
                }
                if(thrustAbbreviationjson[thrustName] == 'BAI'){
                    return 'BRAIN'
                }
                if(thrustAbbreviationjson[thrustName] == 'IEIP'){
                  return 'DGE'
                }
                return thrustAbbreviationjson[thrustName]
            } else {
                return thrustName
            }
        },
        getAbbreviationOriginal(thrustName) {
            thrustName = this.correctThrust(thrustName)
            if (this.thrustAbbreviationjson.hasOwnProperty(thrustName)) {
                return thrustAbbreviationjson[thrustName]
            } else {
                return thrustName
            }
        },
        getHighestDegrees(records) {
            var degreeOrders = ["Doctorate Degree", "Master's Degree", "Bachelor's Degree", "Associate Degree"]
            for (let i = 0; i < records.length; i++) {
                records[i].highestDegreeInfo = []
                for (let j = 0; j < degreeOrders.length; j++) {
                    if (this.degreeGetter(records[i].academic_info, degreeOrders[j]).length != 0) {
                        records[i].highestDegreeInfo = this.degreeGetter(records[i].academic_info, degreeOrders[j])
                        break
                    }
                }
            }
        },
        degreeGetter(academic_info, name) {
            var result = []
            for (let i = 0; i < academic_info.length; i++) {
                if (academic_info[i].qualification == name) {
                    result.push({
                        "start": academic_info[i].qualification_period[0], "end": academic_info[i].qualification_period[1],
                        "degree": academic_info[i].qualification, "university": academic_info[i].qualification_institution,
                        "to_present": academic_info[i].to_present
                    })
                }
            }
            return result
        },
        // selector methods
        //selector methods
    },
}
